import React, {useState} from 'react'
import ContactSection from '../ContactSection/Index';
import '../NotFoundPage/Styles.css';
import useTitle from '../../useTitle';
import { Link } from 'react-router-dom';  // Import Link from react-router-dom

const NotFound = () => {
    useTitle("Oeps! Deze pagina bestaat niet");
     // eslint-disable-next-line no-unused-vars
        const [isOpen, setIsOpen] = useState(false);
        // Close the navbar when a link is clicked
        const handleLinkClick = (url) => {
            setIsOpen(false); // Close the navbar
            window.location.href = url; // Force navigation to the specific URL
        };
  return (
    <>
    <div className='notFoundContainer'>
        <div className='notFoundTitleContainer'>
            <h1 className='notFoundTitle'>Error 404 - Not Found</h1>
        </div>
        <div className='notFoundDescriptionContainer'>
            <p>Oeps! De pagina die je zoekt bestaat niet of is verplaatst.</p>
            <p>Controleer de URL of ga terug naar onze homepagina.</p>
        </div>
          <div className='notFoundButtonContainer'>
            <Link onClick={() => handleLinkClick('/')}  className='notFoundHomePaginaButton'>Ga terug naar de Homepagina</Link>
        </div>

    </div>
    <ContactSection />
      
    </>
  )
}

export default NotFound;
